import { createFileRoute } from '@tanstack/react-router'

import UserManagement from '@/features/Admin/UserManagement'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/_authenticated/admin/users')({
    component: RouteComponent,
    onError: RouteErrorComponent,
})

function RouteComponent() {
    return <UserManagement />
}
